﻿import classNames from "classnames";
import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { isLookup, MenuOptionValue } from "../../types";
import { formatBoolean } from "../../types/utils";
import styles from "./HeaderMenuOption.module.css";

export interface Option {
  value: MenuOptionValue;
  selected?: boolean;
}

interface HeaderMenuOptionProps {
  option: Option;
  optionSuffix?: string;
  updateFilters: (option: Option) => void;
  formatter?: (value: MenuOptionValue) => string | undefined;
  className?: string;
}

const HeaderMenuOption: FC<HeaderMenuOptionProps> = (props: HeaderMenuOptionProps) => {
  const i18n = useI18n();

  const onChange = () => {
    const option: Option = {
      value: props.option.value,
      selected: !props.option.selected,
    };

    props.updateFilters(option);
  };

  const formattedValue = props.formatter?.(props.option.value) ?? props.option.value;

  const value =
    formattedValue === null || formattedValue === undefined || formattedValue === ""
      ? `(${i18n.t.common.empty})`
      : isLookup(formattedValue)
      ? formattedValue.value
      : formattedValue === true || formattedValue === false
      ? formatBoolean(i18n.t, formattedValue)
      : formattedValue;

  const optionId = `${Math.random()}`;

  return (
    <label>
      <div className={classNames(props.className, styles.option)}>
        <input type="checkbox" id={optionId} checked={props.option.selected} onChange={onChange} />
        <div className={styles.unselectable}>{props.optionSuffix ? value + " " + props.optionSuffix : value}</div>
      </div>
    </label>
  );
};

export default HeaderMenuOption;
